import styled from 'styled-components';
import { ErrorProps } from '../../types';

export const Container = styled.div<ErrorProps>`
  flex: 1;
  display: flex;
  flex-direction: row;
  min-height: 40px;
  border: 1px solid
    ${({ error }) =>
      error ? 'var(--chakra-colors-feedback-negative-100)' : '#f1f1f1'};
  background-color: #f1f1f1;
  border-radius: 0.25rem;
`;

export const IconContainer = styled.div`
  flex: 1;
  display: flex;
  background-color: #f1f1f1;
  padding: 0 0.75rem 0 0.75rem;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem 0px 0px 0.25rem;
  max-width: 25px;
`;

export const InputContainer = styled.div`
  flex: 1;
  display: flex;
`;
